// src/components/Dashboard.js
import React from 'react';
import { Container, Header, Loader, Segment, Message } from 'semantic-ui-react';
import UploadIcon from './UploadIcon';
import SubmissionList from './SubmissionList';
import Subscribe from './Subscribe';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_51P72pY2L3CUWCWJsX3yLXWreVhiboMacmyC5eQzxLVc09MNCSwSfnAFO8kd7vOojvQILYcx0GlJxY7LiAyh0EQTm00YXokb5Jq');

export default function Dashboard() {
  const { currentUser } = useAuth();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Fetch subscription status from Firestore
    const fetchSubscription = async () => {
      const docRef = doc(db, 'users', currentUser.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setIsSubscribed(docSnap.data().isSubscribed);
      }
      setLoading(false);
    };
    
    fetchSubscription();
  }, [currentUser.uid]);
  
  if (loading) return <Loader active />;
  
  return (
    <Container style={{ marginTop: '7em' }}>
      <Header as='h2'>Dashboard</Header>
      
      {!isSubscribed && (
        <Segment>
          <Header as='h3'>Subscribe to Access Animation Features</Header>
          <Elements stripe={stripePromise}>
            <Subscribe />
          </Elements>
        </Segment>
      )}
      
      {isSubscribed && (
        <>
          <Segment>
            <UploadIcon />
          </Segment>
          <Segment>
            <Header as='h3'>Your Submissions</Header>
            <SubmissionList />
          </Segment>
        </>
      )}
    </Container>
  );
}
